<template>
  <div class="flex flex-col items-stretch bg-body min-h-screen bg-theme-bg">
    <Navbar type="limited" authRole="distributor" />
    <div class="flex items-stretch w-full min-h-screen">
      <div class="contents">
        <div class="inner-wrapper">
          <router-view />
        </div>
      </div>
    </div>
    <Footer :isLimited="true" :fullWidth="true" />

    <ContactRep @openCalendlyModal="openCalendlyModal" />

    <!-- Calendly modal -->
    <ModalFull
      :is-visible="showCalendly"
      :reset-container="true"
      container-class="w-full max-w-5xl"
      :isOverApp="true"
      :isBlurOverlay="true"
    >
      <div class="w-full rounded-lg bg-white shadow-box">
        <div class="flex justify-between px-5 py-3 w-full">
          <div class="flex items-start justify-start space-x-3">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-4 w-4 flex-shrink-0">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z" />
            </svg>
            <h3 class="text-lg text-theme-secondary font-semibold">Schedule a meeting</h3>
          </div>
          <div class="close cursor-pointer hover:bg-sky-700" @click="showCalendly = false">
            <span>X</span>
          </div>
        </div>
        <div
          class="calendly-inline-widget"
          id="calendly-inline-widget"
          style="position: relative; min-width: 320px; height: 90vh;"
          data-auto-load="false"
        ></div>
      </div>
    </ModalFull>
  </div>
</template>

<script>
import { ref } from "vue";
import Navbar from "./modules/Navbar.vue";
import Footer from "./modules/Footer.vue";
import ContactRep from "./modules/ContactRep.vue";

export default {
  name: "NavbarLayout",
  components: {
    Navbar,
    Footer,
    ContactRep,
  },
  setup() {
    const showCalendly = ref(false);

    const openCalendlyModal = (url) => {
      showCalendly.value = true;
      setTimeout(() => {
        window.Calendly?.initInlineWidget({
          url,
          parentElement: document.getElementById("calendly-inline-widget"),
        });
      }, 300);
    };

    return { showCalendly, openCalendlyModal };
  },
};
</script>

<style lang="scss" scoped>
.contents {
  @apply block h-full flex-grow pt-12 mx-auto;
  @include maxContainer();

  .inner-wrapper {
    @apply px-8 py-12;
  }
}
</style>
